const f = {
  getTemplateBuilderQuery: (route, decode = true) => {
    const query = { ...route.query }
    query.userEmail = query.userEmail ? decode ? atob(query.userEmail) : query.userEmail : null
    return query
  },
  camelCaseToCapitalize (eventType) { // JohnDoe --> John doe
    const s = eventType.replace(/([A-Z])/g, ' $1')
    return s.charAt(1).toUpperCase() + (s.slice(2).toLowerCase())
  },
  camelCaseToProperCase (eventType) { // JohnDoe --> John Doe
    return eventType.replace(/([A-Z])/g, ' $1')
  },
  numberFormat (value) { // 1234567 --> 1,234,567
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
  findRefByName (refName) {
    let obj = this
    while (obj) {
      if (obj.$refs[refName]) {
        return obj.$refs[refName]
      }
      obj = obj.$parent
    }
    return undefined
  },
  settingId (element, getIdCallback) {
    if (element && element.getAttribute && !element.getAttribute('id')) {
      const currentId = getIdCallback(element)
      if (currentId) {
        element.setAttribute('id', currentId)
      }
    }
  },
  setIdToNodeAndDescendants (node, getIdCallback) {
    for (let i = 0; i < node.childNodes.length; i++) {
      const child = node.childNodes[i]
      if (child) {
        this.settingId(child, getIdCallback)
        this.setIdToNodeAndDescendants(child, getIdCallback)
      }
    }
  },
  setEjsPager (elementId) {
    const elementDom = document.getElementById(elementId)
    if (!elementDom) return

    let index = 0
    this.setIdToNodeAndDescendants(elementDom, (element) => {
      if (element.getAttribute && (element.getAttribute('aria-label')?.indexOf('Goto') >= 0 ||
                                   element.getAttribute('aria-label')?.indexOf('Go to') >= 0 ||
                                   element.getAttribute('role') === 'listbox')
      ) {
        return `${elementId}${index++}`
      }
    })
  },
  setTableId (elementId) {
    const elementDom = document.getElementById(elementId)
    if (!elementDom) return

    let counter = 1
    this.setIdToNodeAndDescendants(elementDom, (element) => {
      if (element && element.className === 'e-filtermenudiv e-icons e-icon-filter' && element.clientHeight > 0 && element.getAttribute && element.getAttribute('e-mappinguid')) {
        return `flmenu${counter++}`
      }
    })
  },
  setFilterId (element) {
    element.setAttribute('id', 'inputFilter')
    const parentNode = this.getParentNode(element, 5)
    this.setIdToNodeAndDescendants(parentNode, (element) => {
      if (element) {
        switch (element.nodeName) {
          case 'SPAN':
            if (element.getAttribute('role') === 'listbox') {
              return 'selectFilter'
            }
            break
          case 'BUTTON':
            return `btn${element.textContent}`
          default:
            return null
        }
      }
    })
  },
  getParentNode (element, numberToUp) {
    if (numberToUp === 0) {
      return element
    }
    return this.getParentNode(element.parentNode, numberToUp - 1)
  },
  showLongText (bigText, limit) {
    if (bigText.length < limit) return bigText

    const bigTextInArray = bigText.split(',')
    let text = ''
    let countWorlds = 0
    bigTextInArray.map(e => e.trim()).forEach(e => {
      let currentWorld = ', ' + e
      if (text === '') currentWorld = e
      if ((text + currentWorld).length <= limit) {
        text += currentWorld
        countWorlds += 1
      }
    })

    const totalWorlds = bigTextInArray.length - countWorlds
    if (totalWorlds > 99) {
      return `${text} <span class="longTextNumber">+99</span>`
    } else if (totalWorlds > 0 && totalWorlds <= 99) {
      return `${text} <span class="longTextNumber">+${bigTextInArray.length - countWorlds}</span>`
    } else {
      return `${text}`
    }
  }
}

export default {
  install (vue) {
    vue.helpers = f
    vue.prototype.$helpers = f
  }
}
